
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[uuid]",
      function () {
        return require("private-next-pages/s/[uuid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[uuid]"])
      });
    }
  